module.exports = __webpack_public_path__ + "img/link.8752a6f2.svg";